import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { verifyauthCheck, getRunningUnitsList } from "../handlers/adminApi";
import { formatPriceInUSD } from '../handlers/helpers';
import { DotLoader } from 'react-spinners'; // Import DotLoader
import { faEye, faTrash, faPenToSquare, faDownload, faChevronDown, faLocationDot, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Papa from 'papaparse';


function RunningUnits() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [deleteIndex, setDeleteIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [winningResults, setWinningResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showExportModal, setShowExportModal] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [selectedResults, setSelectedResults] = useState([]); // Track selected results for deletion
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const [formData, setFormData] = useState({
    monthYear: '',
    units: '',
  });
  const navigate = useNavigate();
  const location = useLocation();
  const tipsPerPage = 8; // Set to 8 for displaying 8 results per page

  const totalTips = winningResults.length; // Total number of results
  const totalPages = Math.ceil(totalTips / tipsPerPage); // Calculate total number of pages

  // Calculate the index range for the current page's data
  const indexOfLastEntry = currentPage * tipsPerPage;
  const indexOfFirstEntry = indexOfLastEntry - tipsPerPage;
  const currentRunningUnits = winningResults.slice(indexOfFirstEntry, indexOfLastEntry); // Get the results for the current page

  // Handle page change (updates the current page state)
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const openDeleteModal = (id) => {
    setDeleteIndex(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteIndex(null);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const runningunitId = deleteIndex;
    console.log(`Deleting item with runningunitId: ${runningunitId}`);

    if (runningunitId === null || runningunitId === undefined) {
      console.error('No valid runningunitId provided for deletion');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/runningunits/delete-running-unit/${runningunitId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseData = await response.json();  // Log the response from the API
      console.log('Delete response:', responseData);

      if (response.ok) {
        const updatedResults = winningResults.filter(result => result.runningunitId !== runningunitId);
        setWinningResults(updatedResults);
        closeDeleteModal();
        window.location.reload();
      } else {
        console.error('Failed to delete the result');
      }
    } catch (error) {
      console.error('Error occurred while deleting the result:', error);
    }
  };

  const openAddModal = () => {
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
  };
  const handleSave = async (e) => {
    e.preventDefault();
    console.log('Saving new result...', formData);

    // Format the monthYear (remove time part if needed)
    const formattedMonthYear = moment(formData.monthYear).format("YYYY-MM");

    const dataToSend = {
      ...formData,
      monthYear: formattedMonthYear,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/runningunits/add-running-unit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),  // Send the formatted date
      });
      console.log('API response status:', response.status);
      const responseData = await response.json();
      console.log('Save response:', responseData);

      if (response.ok) {
        const newResult = responseData;  // Assuming the response returns the added result
        setWinningResults([newResult, ...winningResults]);
        closeAddModal();
        window.location.reload();
      } else {
        console.error('Failed to save the Running Units');
      }
    } catch (error) {
      console.error('Error occurred while saving the Running Units:', error);
    }
  };


  const hasRun = useRef(false);
  const authCheck = async () => {
    var resp = await verifyauthCheck();
    if (resp != null) {
      if (resp.status === true) {
        navigate(location.pathname, {
          state: { ...location.state, userData: resp.userData }
        })
      } else {
        navigate("/")
      }
    }
  };

  const getWinningResults = async () => {
    setLoading(true);
    const allResults = [];
    const totalPages = 5; // Adjust this based on the API response

    for (let page = 1; page <= totalPages; page++) {
      // var resp = await getRunningUnitsList({ 'page': page.toString() });
      var resp = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/runningunits/get-all-running-units?page=${page}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const responseData = await resp.json();

     
      const pageData = _.get(responseData, 'data', []);

      allResults.unshift(...pageData);
      const sortedResults = pageData.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setWinningResults(sortedResults);
    }

    setLoading(false);
  };


  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      authCheck();
      getWinningResults();
    }
  }, []);


  useEffect(() => {
    getWinningResults(); // Fetch all the results when the component mounts
  }, []);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
    console.log('Updated formData:', formData);
  };


  const handleSelectAllChange = () => {
    if (selectAllChecked) {
      setSelectedResults([]); // If Select All is checked, uncheck all
    } else {
      const allIds = winningResults.map((tip) => tip.id); // Get all result IDs from the list
      setSelectedResults(allIds); // Select all results
    }
    setSelectAllChecked(!selectAllChecked); // Toggle the Select All state
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (resultId) => {
    setSelectedResults(prevSelected => {
      let newSelected;
      if (prevSelected.includes(resultId)) {
        newSelected = prevSelected.filter(id => id !== resultId); // Remove the ID if it's already selected
      } else {
        newSelected = [...prevSelected, resultId]; // Add the ID to the selection
      }

      // Check if all results are selected
      setSelectAllChecked(newSelected.length === winningResults.length);
      return newSelected;
    });
  };

  const handleDeleteSelected = async () => {
    console.log("Selected results before API call:", selectedResults);  // Log selectedResults

    const selectedIds = selectedResults;

    if (selectedIds.length === 0) {
      alert("No results selected for deletion.");
      return;
    }

    try {
      // Instead of passing the IDs as query string, send them in the request body
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/runningunits/delete-all-running-units`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ids: selectedIds }),  // Send the IDs as JSON
      });

      console.log('API response status:', response.status);
      console.log('API response statusText:', response.statusText);
      console.log('API response headers:', response.headers);

      // Parse the response body
      const responseData = await response.json();
      console.log('API response body:', responseData);

      // Check if the deletion was successful
      if (response.ok && responseData.status) {
        console.log('Delete response:', responseData);

        // Update UI by removing the deleted results
        const updatedResults = winningResults.filter(result => !selectedIds.includes(result.id));

        setWinningResults(updatedResults);
        // alert('Selected results deleted successfully!');
      } 
    } catch (error) {
      console.error('Error occurred while deleting selected results:', error);
      alert('An error occurred while deleting the selected results. Please try again.');
    }
  };
  const handleEditClick = (runningUnit) => {
    setFormData({
      monthYear: runningUnit.month_year || "",
      units: runningUnit.units || "",
      id: runningUnit.id,
    });
    setShowEditModal(true);
  }



  const handleEditsave = async () => {
    const formattedMonthYear = moment(formData.monthYear).format("YYYY-MM");
    const dataToSend = {
      ...formData,
      monthYear: formattedMonthYear,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/runningunits/edit-running-unit`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const responseData = await response.json();

      if (response.ok) {
        const updatedResult = responseData;
        setWinningResults(prevResults => prevResults.map(result => result.id === updatedResult.id ? updatedResult : result));
        setShowEditModal(false);
      } else {
        console.error('Failed to edit the Running Unit');
      }
    } catch (error) {
      console.error('Error occurred while editing the Running Unit:', error);
    }
  }

  return (
    <div className="result-main running-units">
      <div className="middle">
        <div className="right3">
          <div className="title">
            <h2>Running Units</h2>
          </div>

          {loading ? (
            <div className="loader-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px', marginTop: '90px' }}>
              <DotLoader color="#F7812A" loading={loading} size={60} />
            </div>
          ) : (
            <div className="table running-units">

              <div className="button-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="export-button-container">

                  <a className="export-button1" style={{ cursor: 'pointer' }} >
                    <input
                      type="checkbox"
                      style={{
                        borderColor: 'orange',
                        outline: 'none',
                        cursor: 'pointer',
                        width: '17px',
                        height: '17px'
                      }}
                      checked={selectAllChecked}  // Bind the "Select All" checkbox state
                      onChange={handleSelectAllChange}
                    />
                    Select All
                  </a>
                </div>
                <div className="add-new-list-container">
                  <a style={{ cursor: 'pointer' }} className="add-new-list-button" onClick={openAddModal}>+ Add Units</a>
                </div>

                <div className="export-btn-container" style={{ marginLeft: 'auto', marginRight: '10px', cursor: 'pointer' }}>
                  <a className="export-btn" onClick={handleDeleteSelected}>
                    Delete Units
                  </a>
                </div>
              </div>

              <div className="table-wrapper" style={{ overflowX: 'auto' }}>
                <table className='table-contentss'>
                  <tr className='table-headerss'>
                    <th>Months & Year</th>
                    <th>Units</th>
                  </tr>

                  {/* {currentRunningUnits.map((unit, index) => (
                    <tr key={index}>
                      <td style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <input
                          type="checkbox"
                          style={{
                            borderColor: 'orange',
                            outline: 'none',
                            cursor: 'pointer',
                            width: '20px',
                            height: '17px'
                          }}
                          checked={selectedResults.includes(unit.result_id)}
                          onChange={() => handleCheckboxChange(unit.result_id)} />
                        <span style={{ marginLeft: '10px' }}>
                          {moment(unit.monthYear).format("MMMM YYYY")}
                        </span>


                      </td>
                      <td>{unit.units}</td>
                      <td>
                        <a onClick={(e) => openDeleteModal(unit.result_id)} style={{ color: 'red', marginLeft: 20, cursor: 'pointer' }}>
                          <FontAwesomeIcon icon={faTrash} style={{ color: 'red', marginLeft: 20 }} />
                        </a>
                        <a style={{ cursor: 'pointer' }} onClick={() => handleEditClick(unit)}>
                          <FontAwesomeIcon icon={faPenToSquare} style={{ color: 'grey', marginLeft: 20 }} />
                        </a>
                      </td>
                    </tr>
                  ))} */}
                  {currentRunningUnits.map((unit, index) => (
                    <tr key={unit.id}>
                      <td style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <input
                          type="checkbox"
                          checked={selectedResults.includes(unit.id)}   //  use id
                          onChange={() => handleCheckboxChange(unit.id)}
                        />
                        <span style={{ marginLeft: '10px' }}>
                          {unit.month_year
                            ? moment(unit.month_year, "YYYY-MM").format("MMMM YYYY")
                            : moment(unit.created_at).format("D MMM YYYY")}
                        </span>
                      </td>
                      <td>
                        {unit.units}
                        <a onClick={() => openDeleteModal(unit.id)} style={{ color: 'red', marginLeft: 20, cursor: 'pointer' }}>
                          <FontAwesomeIcon icon={faTrash} />
                        </a>
                        <a style={{ cursor: 'pointer' }} onClick={() => handleEditClick(unit)}>
                          <FontAwesomeIcon icon={faPenToSquare} style={{ color: 'grey', marginLeft: 20 }} />
                        </a>
                      </td>
                    </tr>
                  ))}

                </table>
              </div>
              <hr className="horizontal-line" />

              <div className="pagination">
                <span>
                  Showing  {Math.min(indexOfLastEntry, totalTips)} of {totalTips} entries
                </span>
                <div className="pagination-buttons">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={currentPage === index + 1 ? 'active' : ''}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="edit-form change-sub">
            <div className="form">
              <form>
                <h2>Delete</h2>
                <p>Are you sure you want to Delete?</p>

                <div className="theme-btn log-out">
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }}
                      onClick={handleDelete}>Delete</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }}
                      onClick={closeDeleteModal}>Cancel</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Add Result Modal */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="edit-form result-edit">
            <div className="form">
              <form>
                <h2>Add Result</h2>

                {/* Result Date */}
                <div className="form-group">
                  <label htmlFor="monthYear">Month and Year</label>
                  <input
                    type="month"

                    id="monthYear" // Matches the state key
                    value={formData.monthYear}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Track */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="unit">Units</label>
                    <input
                      type="text"
                      id="units" // Matches the state key
                      value={formData.units}
                      onChange={handleInputChange}
                      placeholder="Enter Units"
                    />
                  </div>

                </div>



                {/* Save/Cancel Buttons */}
                <div className="theme-btn" style={{ marginTop: 50, marginBottom: 30 }}>
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }} onClick={handleSave}>Save Changes</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }} onClick={closeAddModal}>Cancel</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Edit Running Units */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="edit-form result-edit">
            <div className="form">
              <form>
                <h2>Edit Running Units</h2>

                {/* Result Date */}
                <div className="form-group">
                  <label htmlFor="monthYear">Month and Year</label>
                  <input
                    type="month"
                    id="monthYear" // Matches the state key
                    value={formData.monthYear}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Track */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="units">Units</label>
                    <input
                      type="text"
                      id="units" // Matches the state key
                      value={formData.units}
                      onChange={handleInputChange}
                      placeholder="Enter Units"
                    />
                  </div>

                </div>



                {/* Save/Cancel Buttons */}
                <div className="theme-btn" style={{ marginTop: 50, marginBottom: 30 }}>
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }} onClick={handleEditsave}>Save Changes</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }} onClick={handleCloseModal}>Cancel</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

export default RunningUnits;
